import React from "react";
import { Cards } from "@phosphor-icons/react";
import { RuleToggle } from "@/components/UnbrokenChainToggle";

// Optional "Same tiles" game (Jack, 2026-10-30): both players draw from the
// same bag in the same order, and the opponent's tiles show blank until the game ends.
export default function SameTilesToggle(props) {
  return (
    <RuleToggle {...props} Icon={Cards} title="Same tiles"
      text="You both draw the same tiles in the same order. Their tiles show blank until the end." />
  );
}
